<nb-card *ngIf="match" class="card-match">
    <nb-card-header>
        <div class="match-participants">
            <div class="match-participants__group">
                <div class="match-participant" *ngFor="let participant of match.participantGroup[0].participants">
                    <div class="match-participant__img">
                        <img [src]="participant.url_avatar" [alt]="participant.nome" width="72" height="72" />
                    </div>
                    <p class="match-participant__name">
                        {{ participant.nome }}
                    </p>
                </div>
            </div>
            <div class="participant__vs">vs</div>
            <div class="match-participants__group">
                <div class="match-participant" *ngFor="let participant of match.participantGroup[1].participants">
                    <div class="match-participant__img">
                        <img [src]="participant.url_avatar" [alt]="participant.nome" width="62" height="62" />
                    </div>
                    <p class="match-participant__name">
                        {{ participant.nome }}
                    </p>
                </div>
            </div>
        </div>
    </nb-card-header>
    <nb-card-body>
        <nb-list>
            <nb-list-item>
                <span>{{ "GENERAL.CATEGORIES" | translate }}</span>
                <span>{{ match.geral.nome_categoria }}</span>
            </nb-list-item>
            <nb-list-item>
                <span>{{ "GENERAL.LOCAL" | translate }}</span>
                <span>{{ match.local.nome_local }}</span>
            </nb-list-item>
            <nb-list-item>
                <span>{{ "CONTACT-PAGE.ADDRESS" | translate }}</span>
                <span>{{ match.local.endereco }}</span>
            </nb-list-item>
            <nb-list-item>
                <span>{{ "GENERAL.COURT" | translate }}</span>
                <span>{{ match.quadra?.descricao || "-" }}</span>
            </nb-list-item>
            <nb-list-item>
                <span>{{ "GAME.GAME-DATE" | translate }}</span>
                <span>{{ match.dt_jogo + ", " + match.hr_jogo }}</span>
            </nb-list-item>
        </nb-list>
    </nb-card-body>
</nb-card>
